var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.docNumberFormat.currencyid != _vm.corpCurrency
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    this.$l10n.__(
                      "La devise de votre document est différente de la devise de votre compte, les marges ne seront pas calculées."
                    )
                  ) +
                  "\n        "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("creditnote", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.creditnotesLoaded,
            expression: "creditnotesLoaded"
          }
        ],
        staticClass: "mb-4",
        on: { update: _vm.reloadKPI }
      }),
      _vm._v(" "),
      _c("purchase", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.purchasesLoaded,
            expression: "purchasesLoaded"
          }
        ],
        staticClass: "mb-4",
        on: { update: _vm.reloadKPI }
      }),
      _vm._v(" "),
      _vm.hasExpensePlugin
        ? _c("expense", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.expensesLoaded,
                expression: "expensesLoaded"
              }
            ],
            staticClass: "mb-4",
            on: { update: _vm.reloadKPI }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("row", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.rowsLoaded,
            expression: "rowsLoaded"
          }
        ],
        staticClass: "mb-4",
        on: { update: _vm.reloadKPI }
      }),
      _vm._v(" "),
      _c("custom", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.customsLoaded,
            expression: "customsLoaded"
          }
        ],
        staticClass: "mb-4",
        on: { update: _vm.reloadKPI }
      }),
      _vm._v(" "),
      _vm.hasTimeTrackingPlugin
        ? _c("time-tracking", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.timetrackingsLoaded,
                expression: "timetrackingsLoaded"
              }
            ],
            on: { update: _vm.reloadKPI }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }